<fa-icon
  [icon]="['fas', icon]"
  [size]="size"
  [spin]="spin"
  [styles]="styles"
></fa-icon>
